import React, { PureComponent } from 'react'
import Button from './button'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import ContextButton from './contextButton'
import { showShareContextMenu } from 'aria-viewer/contextmenu/contextMenuActions'
import { connect } from 'react-redux'
import SVG from 'public/assets/svg/icons/raw/icon_social_share.raw.svg'

class ShareButton extends PureComponent {
    render() {
        const { offsetX, offsetY, showShareContextMenu, theme, children, className = 'socialShare' } = this.props

        return (
            <ContextButton
                id="share"
                offsetX={offsetX}
                offsetY={offsetY}
                onClick={showShareContextMenu}
                aria-label="Share experience"
                theme="share_button"
                {...this.props}
            >
                <div className={className} style={theme && theme.svg} dangerouslySetInnerHTML={{ __html: SVG }} />
                {children}
            </ContextButton>
        )
    }
}

export default connect(
    null,
    {
        showShareContextMenu,
    }
)(ShareButton)
